import React from 'react'
import { Paper, Stack, SimpleGrid, Group, Divider, Text } from '@mantine/core'
import { Review, Notes } from '../../../../types'
import { reviewNotes } from '../../../../utils/review'
import Note from '../../../../components/Note'
import { SectionLabel } from './SectionLabel'

export const NotesGrid = (props: { review: Review }) => {
  const { review } = props
  return (
    <Paper p="lg" radius="md" withBorder>
      <Stack gap="md">
        <SectionLabel>Notes par critère</SectionLabel>
        <Divider />
        <SimpleGrid cols={5} spacing={6}>
          {reviewNotes.map((note) => {
            const value = (review as Review & Notes)[note.name as keyof Notes]
            if (!value) return null
            return (
              <Group
                key={note.name} justify="space-between" wrap="nowrap"
                style={{ padding: '6px 10px', borderRadius: 6, background: 'var(--mantine-color-gray-0)' }}
              >
                <Text size="sm" c="dimmed">{note.label}</Text>
                <Note note={value} size="small" />
              </Group>
            )
          })}
        </SimpleGrid>
      </Stack>
    </Paper>
  )
}
